import { colors } from "@mui/material";

import theme from "@theme/index";

const formInputRadius = "12px";

const FilterStyles = {
  autoComplete: {
    // Autocomplete Clear Icon
    ".MuiAutocomplete-clearIndicator, .MuiAutocomplete-popupIndicator": {
      "& : hover": {
        color: theme.palette.secondary.main,
      },
      color: colors.grey[500],
    },

    // Autocomplete Options
    ".MuiAutocomplete-option": {
      py: 1,
    },
    ".MuiAutocomplete-option:hover, .MuiAutocomplete-option strong": {
      backgroundColor: theme.palette.action.hover,
    },

    '.MuiAutocomplete-option[aria-selected="true"]': {
      backgroundColor: theme.palette.action.selected,
    },

    // Autocomplete Tags and Tag Limit
    ".MuiAutocomplete-tag": {
      fontWeight: "600",
    },

    // Autocomplete Chip Delete Icon
    ".MuiChip-deleteIcon": {
      "&:hover": {
        color: `${theme.palette.common.white} !important`,
      },
      color: `${colors.grey[300]} !important`,
      fontSize: "1.25rem",
    },

    // Autocomplete Chips
    ".MuiChip-root": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },

    ".MuiOutlinedInput-root": {
      backgroundColor: "white !important",
    },

    "& .MuiInputBase-root": {
      borderRadius: formInputRadius,
    },
  },
  checkboxLabel: {
    alignItems: "center",
    display: "flex",
    fontSize: "0.875rem",
    fontWeight: 600,
    textWrap: "nowrap",
  },
  container: {
    // Disabled
    ".Mui-disabled": {
      color: colors.grey[400],
    },
    ".MuiInputLabel-root": {
      color: `${colors.grey[600]} !important`,
    },
    // Input Unfocused
    ".MuiOutlinedInput-notchedOutline": {
      borderColor: colors.grey[600],
    },
    // Input Focused
    ".MuiOutlinedInput-notchedOutline legend": {
      borderColor: theme.palette.secondary.main,
    },
    ".MuiTypography-subtitle2": {
      fontWeight: "bold !important",
    },
    // Input Hover
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: `${theme.palette.secondary.main} !important`,
    },
    alignItems: "flex-start",
    display: "flex",

    flexDirection: "row",

    flexGrow: 1,

    flexWrap: "wrap",

    gap: "40px 32px",

    justifyContent: "stretch",

    width: "100%",
  },
  description: {
    color: colors.grey[600],
    fontWeight: 400,
  },
  drawer: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    overflowY: "auto",
    px: {
      lg: 6,
      sm: 3,
      xs: 2,
    },
    py: 4,
    width: "100%",
  },
  filtersGap: 4,
  floatingLabel: {
    cursor: "help",
    fontWeight: "700",
    mb: 0.25,
  },
  headerContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: 2,
    width: "inherit",
  },
};

export default FilterStyles;
